import { render, staticRenderFns } from "./ProjectClients.vue?vue&type=template&id=46a8ef16&scoped=true&"
import script from "./ProjectClients.vue?vue&type=script&lang=js&"
export * from "./ProjectClients.vue?vue&type=script&lang=js&"
import style0 from "./ProjectClients.vue?vue&type=style&index=0&id=46a8ef16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a8ef16",
  null
  
)

export default component.exports